










import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class InnerContent extends Vue {
  @Prop() private values!: String[]
  @Prop() private secondValues!: String[]
  @Prop() private colors!: String[]

  fontColor(index: number) {
    return 'color:' + this.colors[index]
  }
}
